import React from 'react';
import EmailEditor from 'react-email-editor';
export default function HTMLEditor({ data = null,  emailEditorRef }) {

    const onLoad = () => {
        const templateJson = {
            body: { rows: [{ cells: [1], columns: [{ contents: [{ type: 'text', values: { text: data } }] }] }] }
        };
        emailEditorRef.current.editor.loadDesign(templateJson);
    }

    return (
        <div className='border border-light overflow-x-auto'>
            <EmailEditor ref={emailEditorRef} onLoad={onLoad} />
        </div>
    )
}